import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainer(producer_id, container_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/show_container/${producer_id}/fetch_container/${container_id}`
    );
  },

  fetchContainerFiles(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/show_container/${producer_id}/fetch_container_files/${agro_exporter_process_id}`
    );
  },

  fetchAgroExporterProcess(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/show_container/${producer_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchContainerAttachments(producer_id, container_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/show_container/${producer_id}/fetch_container_attachments/${container_id}`
    );
  },

  createContainerAttachment(
    producer_id,
    container_id,
    container_file_id,
    file
  ) {
    let formData = new FormData();
    formData.append("container_attachment[container_attach]", file || "");
    formData.append(
      "container_attachment[exporter_process_container_file_id]",
      container_file_id
    );
    return RequesterV1.post(
      `producer/production/delivery_container/show_container/${producer_id}/create_container_attachment/${container_id}`,
      formData
    );
  },

  destroyContainerAttachment(producer_id, container_attachment_id) {
    return RequesterV1.delete(
      `producer/production/delivery_container/show_container/${producer_id}/destroy_container_attachment/${container_attachment_id}`
    );
  },

  downloadContainerAttachment(producer_id, container_attachment_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/show_container/${producer_id}/download_container_attachment/${container_attachment_id}`,
      { responseType: "blob" }
    );
  }
};
